import { all, takeLatest, put, call, fork } from 'redux-saga/effects'
import { actions, constants } from './actions'
import { apiV2 } from '../../services/api'
import { fetchOrSelectCallTakers } from '../callTakers/sagas'
const { RESOLVE_RETURN_CALL, RETRIEVE_RETURN_CALL, DELETE_RETURN_CALL } = constants

function formatPayload (payload) {
  for (let [key, value] of Object.entries(payload)) {
    if(['returnCallTimezone'].includes(key)) {
      // for select form items, send only value to server, not {label, value}
      payload[key] = value ? value["value"] : ''
    }
  }
  return payload
}


// Action sagas - async
function * getReturnCallsRequest () {
  yield takeLatest('GET_RETURN_CALLS/REQUEST', function * ({ payload }) {
    try {
      const callReports = yield call(apiV2.callReports.getReturnCalls)
      const callTakers = yield call(fetchOrSelectCallTakers)
      yield put(actions.getReturnCalls.success({ callReports, callTakers }))
    } catch (err) {
      yield put(actions.getReturnCalls.failure({ message: 'Failed to retrieve page, please try again.' }))
    }
  })
}

function * retrieveReturnCallRequest () {
  yield takeLatest('RETRIEVE_RETURN_CALL/REQUEST', function * ({ payload }) {
    try {
      const callReport = yield call(apiV2.callReports.getById, payload.id)
      yield put(actions.retrieveReturnCall.success({ source: RETRIEVE_RETURN_CALL, page: callReport }))
    } catch (err) {
      console.log(err)
      yield put(actions.retrieveReturnCall.failure({ source:  RETRIEVE_RETURN_CALL, message: 'Unable to retrieve return call, please try again.' }))
    }
  })
}

function * resolveReturnCallRequest () {
  yield takeLatest('RESOLVE_RETURN_CALL/REQUEST', function * ({ payload }) {
    try {
      let validationErrors = ''
      if (payload.originCallReportId && !payload.returnCallFollowUpNotes) { validationErrors += 'Please add Follow Up Notes. ' }
      if (validationErrors) {
        yield put(actions.resolveReturnCall.failure({ source: RESOLVE_RETURN_CALL, message: validationErrors }))
        return
      }

      const callReportId = payload.id
      // Format payload for V2 API - no need for snake_case conversion
      const formattedPayload = formatPayload(payload)

      // Remove fields that V2 extracts from JWT or doesn't need
      delete formattedPayload.id
      delete formattedPayload.callTakerId

      yield call(apiV2.callReports.update, callReportId, formattedPayload)
      yield put(actions.resolveReturnCall.success({ source: RESOLVE_RETURN_CALL, message: 'Successfully resolved return call.' }))
    } catch (err) {
      yield put(actions.resolveReturnCall.failure({ source: RESOLVE_RETURN_CALL, message: 'Unable to submit return call, please try again.' }))
    }
  })
}

function * deleteReturnCallRequest () {
  yield takeLatest('DELETE_RETURN_CALL/REQUEST', function * ({ payload }) {
    try {
      // V2 API returns 204 No Content on successful deletion
      yield call(apiV2.callReports.delete, payload.callReportId)
      yield put(actions.deleteReturnCall.success({ source: DELETE_RETURN_CALL, message: 'Successfully deleted return call.' }))

      // Refetch return calls list after deletion using V2 endpoint
      const callReports = yield call(apiV2.callReports.getReturnCalls)
      const callTakers = yield call(fetchOrSelectCallTakers)
      yield put(actions.getReturnCalls.success({ callReports, callTakers }))
    } catch (err) {
      yield put(actions.deleteReturnCall.failure({ source: DELETE_RETURN_CALL, message: 'Unable to delete return call, please try again.' }))
    }
  })
}

// Watcher sagas
export default function * rootSaga () {
  yield all([
    fork(getReturnCallsRequest),
    fork(retrieveReturnCallRequest),
    fork(resolveReturnCallRequest),
    fork(deleteReturnCallRequest)
  ])
}
